"use client";

import Image from "next/image";
import { AnimatedSection } from "./motion";

export function HeroImageSection() {
  return (
    <AnimatedSection
      direction="up"
      className="m-auto w-full flex justify-center px-4"
    >
      <div className="relative mt-10 rounded-2xl overflow-hidden shadow-2xl shadow-indigo-500/10 border border-slate-200/60 transition-transform duration-500 hover:scale-[1.01]">
        <div className="absolute inset-0 bg-gradient-to-tr from-indigo-500/5 via-transparent to-pink-500/5 pointer-events-none" />
        <Image
          priority
          className="relative"
          src="/sanketbagadbotbyte.jpeg"
          width={810}
          height={540}
          alt="Sanket Bagad Quoting BotByte AI"
        />
      </div>
    </AnimatedSection>
  );
}
